import React from "react";

const Gear = ({
  style = {},
  width = 20,
  height = 20,
  className = "",
  color = "#888",
  viewBox = "0 0 20 20",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      style={style}
      {...rest}>
      <path
        d="M19.4,11.44,18.18,11a.65.65,0,0,1-.47-.61V9.52a.68.68,0,0,1,.42-.61l1.22-.42A1,1,0,0,0,20,7.42a11.27,11.27,0,0,0-1.13-2.77.84.84,0,0,0-1.17-.32l-1.17.56a.59.59,0,0,1-.75-.14l-.57-.52A.74.74,0,0,1,15,3.48l.57-1.17a1,1,0,0,0-.33-1.17A9.59,9.59,0,0,0,12.5,0a.91.91,0,0,0-1.08.61L11,1.85a.61.61,0,0,1-.61.42H9.54a.68.68,0,0,1-.61-.42L8.56.63A1,1,0,0,0,7.48,0,11.25,11.25,0,0,0,4.71,1.14a.86.86,0,0,0-.33,1.17L5,3.48a.59.59,0,0,1-.14.75l-.57.61A.7.7,0,0,1,3.49,5L2.32,4.37a1,1,0,0,0-1.17.33A9.28,9.28,0,0,0,0,7.46.91.91,0,0,0,.63,8.54L1.85,9a.6.6,0,0,1,.42.61v.89a.66.66,0,0,1-.47.61l-1.17.37A1,1,0,0,0,0,12.52a10.83,10.83,0,0,0,1.13,2.76.85.85,0,0,0,1.17.33L3.49,15a.58.58,0,0,1,.75.15l.61.6a.72.72,0,0,1,.14.75l-.61,1.13a1,1,0,0,0,.33,1.17A9.89,9.89,0,0,0,7.43,20a.93.93,0,0,0,1.08-.56l.42-1.22a.66.66,0,0,1,.61-.47h.85a.66.66,0,0,1,.61.47l.42,1.22A.84.84,0,0,0,12.5,20a9.19,9.19,0,0,0,2.72-1.12.86.86,0,0,0,.33-1.17L15,16.54a.58.58,0,0,1,.14-.75l.61-.6a.72.72,0,0,1,.75-.15l1.17.57a1,1,0,0,0,1.17-.33A9.56,9.56,0,0,0,20,12.52.84.84,0,0,0,19.4,11.44ZM10,14.34A4.35,4.35,0,1,1,14.38,10,4.34,4.34,0,0,1,10,14.34Z"
        transform="translate(0 0)"
        fill={color}
      />
    </svg>
  );
};

export default Gear;
